// Polished "time's up" flash over the stage when the shared timer reaches 0.
// Visual only — the chime is played by the store, and reaching 0 never ends the
// meeting. Renders a brief green pulse (CSS keyframe), once per completion, then
// unmounts. pointer-events: none, so it never blocks the call.

import { memo, useEffect, useRef, useState } from 'react';

import { useTimerStore } from '../store/timerStore';

export const TimerFlash = memo(function TimerFlash() {
  const status = useTimerStore((s) => s.status);
  const prev = useRef(status);
  const [flashing, setFlashing] = useState(false);

  useEffect(() => {
    if (status === 'done' && prev.current !== 'done') {
      setFlashing(true);
      const t = setTimeout(() => setFlashing(false), 1700);
      prev.current = status;
      return () => clearTimeout(t);
    }
    prev.current = status;
  }, [status]);

  if (!flashing) return null;
  return <div className="bz-timer-flash" aria-hidden="true" />;
});
